
import { useRouter } from "next/router";
import React, { useContext, useState, useTransition } from "react";
import { useForm } from 'react-hook-form'
import userModel from "../../models/user.model";
import Heading from "../../components/Heading";
import helper from "../../lib/helper";
import _ from "lodash";
import useSWR from 'swr'
const Page = function () {
  const router = useRouter()
  const [showLoader, setShowLoader] = useState(false);
  const [preview, setPreview] = useState('http://ssl.gstatic.com/accounts/ui/avatar_2x.png')
  const { data: rolesList } = useSWR("rolelist", () => rolesModel.list());
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors,isSubmitting },
    setError
  } = useForm();

  const onSelectFile = e => {
    console.log(e.target.files[0])
    // I've kept this example simple by usin;g the first image instead of multiple
    const objectUrl = URL.createObjectURL(e.target.files[0])
    setPreview(objectUrl);
    //setValue("avatar", e.target.files[0]);
  }


  const onSubmit = handleSubmit(async (data, event) => {
    const formData = new FormData(event.target);
    await userModel.create(formData).then((response) => {
      helper.sweetalert.toast(response.data?.message);
      console.log('FormData', formData)
      console.log('response', response)
      router.push('/users')
    }).catch((error) => {
     console.log(error.response?.data?.errors);
      helper.sweetalert.toast(error.response?.data?.message, 'error');
      _.each(error.response?.data?.errors, function (err, errorKey) {
        setError(errorKey, { type: "required", message: err });
      });
    });
  })


  return (
    <>
      <Heading title=" Create User " showLoader={showLoader} />
      <form onSubmit={onSubmit} className="container-fluid">
        <div className="card col-md-12">
          <div className="card-header">Create User</div>
          <div className="card-body row">
            <div className="col-md-3 me-3 position-relative border-end">

              <img src={preview}
                className="w-100 border rounded" alt="" />
              <div className="m-1">
                <label className="custom-file-upload">
                  <input type="file" className="d-none" accept="image/*" {...register('avatar', { onChange: onSelectFile })} />
                  <b className="btn btn-dark">Upload</b>
                </label>


              </div>
            </div>
            <div className="col-md-9 row">
              <div className="col-md-6 mb-2">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  placeholder="Enter Name"
                  className={`form-control ${errors?.name && "is-invalid"}`}
                  {...register("name", {
                    required: "Name is required",
                  })}
                />
              </div>

              <div className="col-md-6 mb-2">
                <label className="form-label">Email</label>
                <input
                  placeholder="Enter Email"
                  type="email"
                  className={`form-control ${errors?.email && "is-invalid"}`}
                  {...register("email", { required: true })}
                />
                <div className="invalid-feedback">
                  {errors.email && errors.email.message}
                </div>
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">Mobile</label>
                <input
                  placeholder="Enter Mobile"
                  type="text"
                  className={`form-control ${errors?.mobile && "is-invalid"}`}
                  {...register("mobile", { required: true })}
                />
                <div className="invalid-feedback">
                  {errors.mobile && errors.mobile.message}
                </div>
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">Password</label>
                <input
                  placeholder="Enter Password"
                  type="password"
                  className={`form-control ${errors?.password && "is-invalid"}`}
                  {...register("password", { required: true })}
                />
                <div className="invalid-feedback">
                  {errors.password && errors.password.message}
                </div>
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">ConfirmPassword</label>
                <input
                  placeholder="Enter ConfirmPassword"
                  type="password"
                  className={`form-control ${errors?.password_confirmation && "is-invalid"}`}
                  {...register("password_confirmation", { required: true })}
                />
                <div className="invalid-feedback">
                  {errors.password_confirmation && errors.password_confirmation.message}
                </div>
              </div>
            </div>
          </div>


          <div className="card-footer">
            <button type="submit" disabled={isSubmitting ? 'disabled' : ''} className="btn btn-primary float-end">
              Save
            </button>
          </div>
        </div>
      </form>
    </>
  );



};

export default Page;